// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__X2Sxl","description":"MealItem_description__V9t7E","price":"MealItem_price__6Smul"};